<template>
  <div class="flex pc-center" style="position: relative;">
    <Goback :title="'返回首页'" :isBack="true" @goBackFunc="goBackFunc" style="position: absolute;left: 20%;top:5%;z-index: 10;"></Goback>
    <Overview class=" pcsingleSiteL" style="position: absolute;left: 0px;top: 0px;z-index: 10;"/>
    <!-- v-if="isStation" -->
    <singleSite class="singleSite" />
    <!-- <ChargingsingleSite class="ChargingsingleSite" v-else/> -->
    <!-- <video id="video" style="width:400px;height:200px" autoplay controls></video> -->
    <div class="flex flex-direction pcsingleSiteR" style="position: absolute;right: 0px;top: 0px;">
      <SiteType></SiteType>
    </div>
  </div>
</template>

<script>
//综合态势
import Goback from "@/components/goBack.vue";
import Overview from "@/views/singleSite/siteOverview";
import singleSite from "@/views/singleSite/singleSite";
import ChargingsingleSite from "@/views/singleSite/ChargingsingleSite";
import SiteType from "@/views/singleSite/siteType.vue";
export default {
  data () {
    return {
      isStation: true
    };
  },
  components: {
    Overview,
    singleSite,
    SiteType,
    Goback,
    ChargingsingleSite
  },
  props: {
    
  },
  mounted(){
      console.log(this.$route,'this.$route.query')
      this.isStation  = this.$route.query.stationType == '换电站' ? true : false
  },
  watch: {
    
  },
  methods: {
    goBackFunc(){
      this.$router.push({
          path: '/pcnationwideSite',
          query: {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
// pc端
.pc-center{
  height:980px;
  .singleSite{
    transform:scale(0.75);
  }

  .ChargingsingleSite{
    transform:scale(0.5);
  }
  @media screen and (max-width: 1440px) {
    height:850px;
  }
}
</style>